module.exports = __webpack_public_path__ + "img/bird-7-left.9b3c0816.png";